import { render, staticRenderFns } from "./ChatBox.vue?vue&type=template&id=48feecef"
import script from "./ChatBox.vue?vue&type=script&lang=js"
export * from "./ChatBox.vue?vue&type=script&lang=js"
import style0 from "./ChatBox.vue?vue&type=style&index=0&id=48feecef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_13f162de80bf2e87404863986ae68eb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports